export default __webpack_public_path__ + "static/media/portfolioWebsiteV1_thumbnail.7f52542e.png";